import React, { useEffect } from 'react'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/styles'
import DigitalMenuAppBar from './DigitalMenuAppBar'
import DigitalMenuFooterBar from './DigitalMenuFooterBar'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { selectors } from '../selectors/loadMenuDataSelectors'
import ErrorScreen from './ErrorScreen'
import LoadingMenu from './LoadingMenu'
import { fetchApiRequest } from '../actions/loadMenuDataActions'
import ScreenSlide from './ScreenSlide'

const useStyles = makeStyles(() => ({
  container: {
    background: '#FFFFFF',
    overflow: 'hidden',
    flexWrap: 'wrap',
    display: 'block',
  },
  footerSeparator: {
    marginTop: '20px',
    opacity: 0,
    border: '1px solid #F2F2F2',
  },
}))

const DigitalMenuScreen = (props) => {
  const classes = useStyles()
  const storeCode = useSelector(selectors.getStoreCode)
  let loading = useSelector(selectors.isLoading)
  const error = useSelector(selectors.getError)

  const paramStoreCode = props.match.params[0].replaceAll('/', '')

  const dispatch = useDispatch()
  const shouldFetch = storeCode !== paramStoreCode && !loading

  useEffect(() => {
      if (shouldFetch) {
        setTimeout(() =>
            dispatch(fetchApiRequest(
              paramStoreCode
            ))
          , 1000)
      }
    }, [dispatch, paramStoreCode, shouldFetch]
  )

  loading = loading || !storeCode || storeCode !== paramStoreCode

  return <>
    {loading && <LoadingMenu/>}
    {!loading && (error || props.error) && <ErrorScreen/>}
    {!loading && !error && !props.error &&
    <Grid container className={classes.container}>
      <Grid item xs={12}>
        <DigitalMenuAppBar handleBackButtonClick={props.handleBackButtonClick}/>
      </Grid>
      <Grid item xs={12}>
        <ScreenSlide>
          <Grid container>
            <Grid item xs={12}>
              {props.children}
            </Grid>
          </Grid>
        </ScreenSlide>
      </Grid>
      <Grid item xs={12}>
        <hr className={classes.footerSeparator}/>
      </Grid>
      <Grid item xs={12}>
        <DigitalMenuFooterBar {...props}/>
      </Grid>
    </Grid>
    }
  </>
}

DigitalMenuScreen.propTypes = {
  children: PropTypes.any,
  handleBackButtonClick: PropTypes.func,
  error: PropTypes.bool,
}

DigitalMenuScreen.defaultProps = {
  error: false
}
export default DigitalMenuScreen
